import { root as actionTypes } from '../constants/action-types';

export const changeTitle = (title, shortTitle) => {
  return { type: actionTypes.CHANGE_TITLE, title, shortTitle };
}

export const hideNotification = () => ({
  type: actionTypes.HIDE_NOTIFICATION
});

export const showNotification = (message, type) => ({
  type: actionTypes.SHOW_NOTIFICATION,
  params: { message, type }
});

export const hideAlert = () => ({
  type: actionTypes.HIDE_ALERT
});

export const showAlert = (title, message, type = 'success') => ({
  type: actionTypes.SHOW_ALERT,
  params: { message, type, title }
});

export const request = () => ({ type: actionTypes.REQUEST });
export const response = () => ({ type: actionTypes.RESPONSE });
export const submitPassword = ({ password }) => ({
  type: actionTypes.SUBMIT_PASSWORD,
  password
});

export const requirePassword = () => ({
  type: actionTypes.REQUIRE_PASSWORD
});

export const clear = reducer => ({
  type: `CLEAR_${reducer.toUpperCase()}`
});



// WEBPACK FOOTER //
// ./src/actions/root.js